











































import Vue from 'vue';
import MStoreDeleteConfirmation from '@/components/shared/MStoreDeleteConfirmation.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { CabinetConfigurationHelper, ModalHelpers } from '@/mixins';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import {
  CabinetConfigurationModel,
  CabinetReferenceType,
  DeleteConfigurationModel,
  DeleteResponseType,
  StoreConstants
} from '@/types';
import { mapActions, mapGetters } from 'vuex';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper, ModalHelpers],
  data() {
    return {
      cabinetConfiguration: {} as CabinetConfigurationModel,
      isLoading: true,
      isSubmitting: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
    ]),
    cardHeader(this: any) {
      return `Delete ${this.cabinetConfiguration.description} Cabinet`;
    },
    documentTypeCount(this: any) {
      return this.cabinetConfiguration.documentTypes?.length ?? 0;
    },
    cabinetReferenceCount(this: any) {
      return (
        (this.cabinetConfiguration as CabinetConfigurationModel).cabinetReferences?.filter(
          (x) => x.referenceType === CabinetReferenceType.Common
        ).length ?? 0
      );
    }
  },
  methods: {
    ...mapActions(StoreConstants.Configuration.ModuleName, [
      StoreConstants.Configuration.Actions.GetConfigurationTree
    ]),
    async getCabinetConfigurationAsync(this: any) {
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(
          this.cabinetId
        );
        this.cabinetConfiguration.configurationChangeId = this[
          StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
        ];
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onDeleteConfirmation(this: any) {
      this.isSubmitting = true;
      try {
        await this.deleteCabinet(false);
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async deleteCabinet(this: any, ignoreWarnings: boolean) {
      const response = await CabinetConfigurationService.deleteCabinetAsync({
        id: this.cabinetId,
        configurationChangeId: this.cabinetConfigurationChangeId,
        continue: ignoreWarnings
      } as DeleteConfigurationModel);

      if (response.deleteResponseType === DeleteResponseType.Deleted) {
        await this[StoreConstants.Configuration.Actions.GetConfigurationTree]();
        SnotifyConfiguration.showSuccess(`Cabinet ${this.cabinetConfiguration.description} successfully deleted`);
        this.navigateToCabinetsDashboard();
        return;
      }

      const userContinue = await this.showNotificationModalAsync(response.notification);
      if (userContinue) {
        await this.deleteCabinet(true);
      }
    },
    async onCancelDeleteConfirmation(this: any) {
      this.navigateToCabinetDashboard(this.cabinetId);
    },
    checkValidLock(this: any) {
      if (this.validLock) {
        return;
      }
      SnotifyConfiguration.showInformation('Sorry, you must be in edit mode to make changes.');
      this.navigateToCabinetDashboard(this.cabinetId);
    }
  },
  async mounted(this: any) {
    await this.getLock();
    await this.getCabinetConfigurationAsync();
    this.checkValidLock();
  },
  created(this: any) {
    this.$route.meta.treePath = `/configuration/cabinet/${this.$route.params.cabinetId}/dashboard`;
    this.cabinetId = this.$route.params.cabinetId;
  },
  beforeDestroy(this: any) {
    this.$route.meta.treePath = null;
  },
  components: {
    MStoreDeleteConfirmation,
    LoadingSpinner
  }
});
